import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Section from '~/layouts/Section ';
import { Person } from '~/types/Person';
import Button from '~/components/Button';
import { isSales } from '~/utils/getDecodedJwt';

interface SignatoryProps {
  onOpen?: () => void;
  readOnly: boolean;
  authorizedSignatoryEmail?: string;
  isCurrentUserAuthorizedSignatory: boolean | undefined;
  resultingAuthorizedRepresentative: Person | undefined;
}

const SignatorySection: React.FC<SignatoryProps> = ({
  resultingAuthorizedRepresentative,
  onOpen,
  readOnly,
  authorizedSignatoryEmail,
  isCurrentUserAuthorizedSignatory,
}) => {
  const { t } = useTranslation('contract');
  const sales = isSales();

  return (
    <>
      {resultingAuthorizedRepresentative && !sales && (
        <Section formItemLast>
          {/* <Typography.Title level={5}>{t('Authorised signatory')}</Typography.Title>
          <Typography.Paragraph>
            {`${resultingAuthorizedRepresentative.firstName} ` +
              `${resultingAuthorizedRepresentative.lastName} ` +
              `(${resultingAuthorizedRepresentative.email}) ` +
              `${longdash} ` +
              `${resultingAuthorizedRepresentative.proof?.designation}`}
          </Typography.Paragraph> */}
          {!isCurrentUserAuthorizedSignatory && (
            <Typography.Paragraph>
              {t(
                'You are unable to procced with submission as you are not the authorized signatory of the company as per our system records.',
              )}
            </Typography.Paragraph>
          )}
          {!isCurrentUserAuthorizedSignatory && (
            <Typography.Paragraph>
              {t('Your agreement has been sent to the {{email}} address to be signed.', {
                email: authorizedSignatoryEmail,
              })}
            </Typography.Paragraph>
          )}
          <Button id="signContract_choosePerson" onClick={onOpen} type="default" size="large" disabled={readOnly}>
            {t('Choose another person')}
          </Button>
        </Section>
      )}
    </>
  );
};

export default SignatorySection;
